import * as React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  DateField,
  FilterButton,
  TopToolbar,
  SelectColumnsButton,
  TextInput,
  EditButton,
  CreateButton
} from 'react-admin'
import { Box } from '@mui/material'

const filters = [
  <TextInput label="Search Group Name" source="name" alwaysOn sx={{ width: '250px' }} resettable />
]

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <CreateButton label="New Provider Group" />
  </TopToolbar>
)

const ProviderGroupList = (props) => {
  return (
    <Box>
      <List
        {...props}
        filters={filters}
        actions={<ListActions />}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <DatagridConfigurable bulkActionButtons={false} rowClick="show">
          <TextField source="name" label="Group Name" />
          <TextField source="adminName" label="Admin Name" />
          <TextField source="adminEmail" label="Admin Email" />
          <DateField source="createdAt" label="Created At" showTime />
          <EditButton label="Edit" />
        </DatagridConfigurable>
      </List>
    </Box>
  )
}

export default ProviderGroupList
